module.exports = __webpack_public_path__ + "static/media/mi1.a9581584.jpg";